import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { Input } from '@mui/material';
import LoaderShow1To2Min  from '../../component/LoaderShow1To2Min.js';


import $ from 'jquery'; // Ensure jQuery is imported for DataTables

export default function TrView() {
  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }
  const tableRef = useRef(null);
  const collegename = localStorage.getItem('username');
  const [loading, setlodaing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [examid, setExamIdData] = useState(false);
  const [getexamData, setExamData] = useState([]);
  const [selectedExam, setSelectedExam] = useState(null); // To track the selected exam for the combo box

  const { http } = Api();

  /* CUSTOM DATA TABLE BEGIN HERE */

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);

  /* CUSTOM DATA TABLE END HERE */

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
      menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
      }),

    }),
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`/getActiveExam`);
        setExamData(response.data.activeexam);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };
    fetchExamData();
  }, []);

  useEffect(() => {
    const storedExamId = localStorage.getItem("examid");

    if (storedExamId && Array.isArray(getexamData)) {
      const exam = getexamData.find(
        e => String(e.examid) === String(storedExamId)
      );

      if (exam) {
        setSelectedExam({
          value: exam.examid,
          label: exam.examtitle
        });
      }
    }
  }, [getexamData]);

  const handleExamChange = (selectedOption) => {
    const examId = selectedOption.value;
    setExamIdData(examId);
    localStorage.setItem('examid', examId);
    setSelectedExam(selectedOption);

  };

  useEffect(() => {
    const fetchDisciplineData = async () => {
      setlodaing(true);
      try {
        const response = await http.post('College/getdiciplineforviewresult', { examid: examid });
        if (Array.isArray(response.data)) {
          setlodaing(false);

          setTableData(response.data);
          localStorage.removeItem("examid");
        } else {
          setlodaing(false);
          localStorage.removeItem("examid");

          setTableData([]); // Ensure it's always an array
        }
      } catch (error) {
        setlodaing(false);
        localStorage.removeItem("examid");

        setTableData([]);
        if (error.response) {
          const { http_status, status_code, message } = error.response.data;
          if (http_status === 401 && status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/college/"), 5000);
          } else if (http_status === 429 && status_code === "ERR33") {
            toast.error(message);
          } else if (http_status === 500 && status_code === "ERR5") {
            toast.error("No data found");
          } else {
            toast.error("Something went wrong");
          }
        } else {
          toast.error("Network error or server is unreachable");
        }
      }
    };
    if (examid) {
      fetchDisciplineData();
    }
  }, [examid]);

  useEffect(() => {
    localStorage.removeItem("examid");

  }, []);

  // useEffect(() => {
  //   if (!loading && tableData.length > 0) {
  //     // Initialize DataTables
  //     const table = $(tableRef.current).DataTable({
  //       destroy: true, // Destroy existing table if reinitializing
  //       paging: false,
  //       searching: true, // Enables the search feature
  //       ordering: true,
  //       info: true,
  //       autoWidth: false,
  //       responsive: true,
  //     });

  //     return () => {
  //       // Clean up the DataTable instance when the component unmounts or updates
  //       table.destroy();
  //     };
  //   }
  // }, [tableData, loading]);
  const handleGenerateNominalRolePDF = async (examid, disciplineid, disciplinename, courseType) => {
    setlodaing(true);
    try {
      const response = await http.post('/College/generateresultpdf', {
        discipline_id: disciplineid,
        examid: examid,
        college_course_type: courseType
      },
        { responseType: 'blob' }
      );

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        // Set the file name and download the PDF
        link.setAttribute('download', `${localStorage.getItem('username')}_${disciplinename}_${courseType}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setlodaing(false);
        return Promise.resolve('PDF generated successfully');
      }
    } catch (error) {
      setlodaing(false);
      console.error('Error generating PDF:', error);
      return Promise.reject('Error generating PDF');
    }
  };

  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  useEffect(() => {
    const filteredAndSortedData = [...tableData].filter(tableDatas => {
      return (
        tableDatas.discipline_name.toLowerCase().includes(searchQuery.toLowerCase())

      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });


    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, tableData, currentPage]);


  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };


  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <>
          {/* <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          
                    <LoaderShow1To2Min />

          </>
        ) : (
          <div className="my-page">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>TR View</h5>
                        </div>

                      </div>
                      <div className="card-body">
                        <div className="card-body pdg">
                          <div className="table-responsive">
                            <div className="form theme-form tab-out-bod">
                              <div className="card-body custom-input">
                                <div className="row">
                                  <div className="col-md-12">
                                    <label>Exam<span className="errorclr">*</span></label>

                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="exam_id"
                                      name="exam_id"
                                      className="basic-select"
                                      classNamePrefix="select"
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      style={customStyles}
                                      options={getexamData.map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle
                                      }))}
                                      onChange={handleExamChange}
                                      value={selectedExam}
                                      placeholder="Select a semester exam..."
                                    />
                                  </div>
                                </div>
                                <div className="txt-aln-jst m-10">
                                </div>
                                <div className='row'>

                                  <div className='col-md-6 wdt' >
                                    <p>
                                      Showing {(currentPage - 1) * 50 + 1}{''}-
                                      {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                    </p>
                                  </div>
                                  <div className='col-md-6 wdt' align='right'>
                                    <input
                                      type="text"
                                      value={searchQuery}
                                      onChange={handleSearchInputChange}
                                      placeholder="Search..."
                                      className='form-control'
                                    /></div></div>
                                <div class="table-container" style={{ overflowX: 'unset' }}>
                                  <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">
                                        <th onClick={() => handleSort('discipline_name')} scope="col" data-label="SL No." width="15%">Sl No
                                          &nbsp;
                                          {renderSortIcon('discipline_name')}
                                        </th>
                                        <th scope="col" data-label="Discipline" width="">Admitted Discipline</th>
                                        {/*<th scope="col" data-label="Course Name" width="">Action</th>
                                       <th scope="col" data-label="Course Type" width="">Course Type</th>
                                        <th scope="col" data-label="Total Student Count" width="" >Total Student Count</th>                                      */}

                                        <th scope="col" data-label="Action" width="">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredAndSortedData.map((item, index) => {

                                        const serialNumber = (currentPage - 1) * 50 + index + 1;
                                        return (


                                          <tr key={index} style={{ textAlign: "center", verticalAlign: "middle" }}>
                                            <td data-label="Sl No.">{serialNumber}</td>
                                            <td data-label="Discipline" >{item.discipline_name}</td>
                                            {/* <td  data-label="Course Name">{item.course_name}</td>
                                            <td  data-label="Course Type">{item.college_course_type}</td>
                                            <td data-label="Total Student Count" style={{textAlign:'center'}}>{item.total_students}</td>                                          */}

                                            <td data-label="Action"><div className="txt-aln-lft" style={{ cursor: 'pointer' }}><i className="fa fa-print icn-out-bod" aria-hidden="true"
                                              title="Download" onClick={() => handleGenerateNominalRolePDF(examid, item.discipline_id, item.discipline_name, item.college_course_type)}></i></div></td>
                                          </tr>
                                        )
                                      })}
                                      {/* ) : (
                                        <tr>
                                          <td colSpan="3" className="text-center">No data found</td>
                                        </tr>
                                      )} */}

                                    </tbody>
                                  </table>
                                </div>
                                {totalPages > 1 && (
                                  <nav aria-label="..." style={{ cursor: "pointer" }}>
                                    <ul className="pagination justify-content-center">
                                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                      </li>
                                      <li className={`page-item`}>
                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                      </li>
                                      {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                      {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                        <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                          <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                        </li>
                                      ))}
                                      {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                      <li className={`page-item`}>
                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                      </li>

                                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                        <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                      </li>
                                    </ul>
                                  </nav>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </Template>
    </>
  );
}
